<script>
import Layout from "@/router/layouts/descontos";
import { mapState } from "vuex";
import { api } from "@/state/services";
import Dropdown from 'primevue/dropdown';

export default {
  locales: {
    pt: {
    },
    es: {
    }
  },
  components: {
    Layout,
    Dropdown,
  },
  computed: {
    ...mapState({
      account: state => state.account
    }),
  },
  data() {
    return {
      states: [
        { code: "AC", name: "Acre", },
        { code: "AL", name: "Alagoas", },
        { code: "AP", name: "Amapá", },
        { code: "AM", name: "Amazonas", },
        { code: "BA", name: "Bahia", },
        { code: "CE", name: "Ceará", },
        { code: "DF", name: "Distrito Federal", },
        { code: "ES", name: "Espírito Santo", },
        { code: "GO", name: "Goiás", },
        { code: "MA", name: "Maranhão", },
        { code: "MT", name: "Mato Grosso", },
        { code: "MS", name: "Mato Grosso do Sul", },
        { code: "MG", name: "Minas Gerais", },
        { code: "PA", name: "Pará", },
        { code: "PB", name: "Paraíba", },
        { code: "PR", name: "Paraná", },
        { code: "PE", name: "Pernambuco", },
        { code: "PI", name: "Piauí", },
        { code: "RJ", name: "Rio de Janeiro", },
        { code: "RN", name: "Rio Grande do Norte", },
        { code: "RS", name: "Rio Grande do Sul", },
        { code: "RO", name: "Rondônia", },
        { code: "RR", name: "Roraima", },
        { code: "SC", name: "Santa Catarina", },
        { code: "SP", name: "São Paulo", },
        { code: "SE", name: "Sergipe", },
        { code: "TO", name: "Tocantins", },
      ],
      cities: [],

      descontos: {
        status: null,
        region: {
          state: null,
          city: null,
        },
      },

      region: {
        loading: false,

        state: null,
        city: null,
      },

      change: {
        modal: false,
        loading: false,
      },

      type: 'discount',
      category: '',
      categories: null,
      partners: null,
    };
  },
  methods: {
    getDescontos() {
      this.loading = true;

      api
        .get('descontos')
        .then((response) => {
          if (response.data.status == 'success') {
            this.descontos.status = response.data.status;
            this.descontos.region = response.data.region;
          }
        })
    },
    getCities() {
      this.region.loading = true;

      if (this.region.state && this.region.state.code) {
        api
          .post('descontos/cidades', {
            state: this.region.state.code
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.cities = response.data.list
            }
          })
          .finally(() => {
            this.region.loading = false;
          })
      }
    },
    changeRegion() {
      this.change.modal = false;
      this.change.modal = true;
      this.region.state = this.descontos.region.state;
      this.region.city = this.descontos.region.city;
      this.getCities();
    },
    saveRegion() {
      if (this.region.state && this.region.city) {
        this.change.loading = true;

        api
          .post('descontos/regiao', {
            state: this.region.state.code,
            city: this.region.city.code
          })
          .then((response) => {
            if (response.data.status == 'success') {
              this.getDescontos();
              this.descontos.region = this.region;
              this.change.modal = false;
              this.change.loading = false;
            } else {
              this.$toast.error(response.data.message);
              this.change.loading = false;
            }
          })

      }
    },
    getCategories() {
      this.category = '';
      this.categories = null;

      api
        .get('descontos/categorias/' + this.type)
        .then((response) => {
          if (response.data.status == 'success') {
            this.categories = response.data.list
          }
        })
    },
    showCategory(row) {
      if (row) {
        this.category = row.id;
      } else {
        this.category = '';
      }

      this.getPartners();
    },
    getPartners() {
      this.partners = null;

      api
        .post('descontos/parceiros', {
          type: this.type,
          category: this.category,
        })
        .then((response) => {
          if (response.data.status == 'success') {
            this.partners = response.data.list
          }
        })
    },
  },
  mounted() {
    this.getDescontos();
    this.getPartners();
    this.getCategories();
  },
  watch: {
    "region.state": function (v) {
      if (v != this.descontos.region.state) {
        this.cities = [];
        this.region.city = null;
        this.getCities();
      }
    },
    "type": function () {
      this.getPartners();
      this.getCategories();
    },
  },
};
</script>

<template>
  <Layout>
    <div class="page-title-box d-flex justify-content-between">
      <div>
        <h3>Descontos</h3>
        <p>Seu clube de descontos.</p>
      </div>
      <div v-if="!descontos.region.state && !descontos.region.city" class="d-none p-3">
        <b-spinner variant="default" role="status" small></b-spinner>
      </div>
      <div v-else-if="descontos.region.state && descontos.region.city" class="d-none text-right pt-2">
        <template v-if="descontos.region.state.code && descontos.region.city.name">
          {{ descontos.region.city.name }}/{{ descontos.region.state.code }}<br>
          <button class="btn btn-outline-default px-2 py-0 rounded-sm" v-on:click="changeRegion()">Alterar</button>
        </template>
        <template v-else>
          Escolha sua região<br>
          <button class="btn btn-outline-default px-2 py-0 rounded-sm" v-on:click="changeRegion()">Alterar</button>
        </template>
      </div>
    </div>

    <b-modal v-model="change.modal" modal-class="modal-right" hide-header hide-footer>
      <h5 class="mb-3">Selecione sua região</h5>
      <Dropdown class="w-100" v-model="region.state" dataKey="code" :options="states" :filter="true" optionLabel="name" placeholder="Selecione o seu estado">
        <template #value="slotProps">
          <div class="p-dropdown-car-value" v-if="slotProps.value.code">
            <span><strong>{{ slotProps.value.code }}</strong> – {{ slotProps.value.name }}</span>
          </div>
          <div v-else>
            <span><strong>{{ slotProps.placeholder }}</strong></span>
          </div>
        </template>
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span><strong>{{ slotProps.option.code }}</strong> – {{ slotProps.option.name }}</span>
          </div>
        </template>
      </Dropdown>
      <Dropdown v-if="region.state && region.state.code" class="w-100 mt-2" v-model="region.city" dataKey="code" :options="cities" :filter="true" optionLabel="name" placeholder="Selecione sua cidade">
        <template #value="slotProps">
          <div class="p-dropdown-car-value" v-if="slotProps.value && slotProps.value.code">
            <span>{{ slotProps.value.name }}</span>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>
        <template #option="slotProps">
          <div class="p-dropdown-car-option">
            <span>{{ slotProps.option.name }}</span>
          </div>
        </template>
      </Dropdown>
      <div class="d-flex justify-content-between align-items-center mt-3">
        <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="this.change.loading" v-on:click="saveRegion();">
          Salvar
          <b-spinner v-if="change.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
        </button>
        <a class="btn btn-outline-link" v-on:click="change.modal = false;">Fechar</a>
      </div>
    </b-modal>

    <div class="d-flex justify-content-center mb-5" style="gap: 10px;">
      <button class="flex-fill rounded p-2 d-flex justify-content-center align-items-center" :class="this.type == 'discount' ? 'bg-default text-white border-0' : 'bg-white text-default border'"
        v-on:click="type = 'discount'">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-piggy-bank mr-2">
            <path d="M19 5c-1.5 0-2.8 1.4-3 2-3.5-1.5-11-.3-11 5 0 1.8 0 3 2 4.5V20h4v-2h3v2h4v-4c1-.5 1.7-1 2-2h2v-4h-2c0-1-.5-1.5-1-2V5z"></path>
            <path d="M2 9v1c0 1.1.9 2 2 2h1"></path>
            <path d="M16 11h.01"></path>
          </svg>
        </div>
        <div>Descontos</div>
      </button>
      <button class="flex-fill rounded p-2 d-flex justify-content-center align-items-center" :class="this.type == 'cashback' ? 'bg-default text-white border-0' : 'bg-white text-default border'"
        v-on:click="type = 'cashback'">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-hand-coins mr-2">
            <path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"></path>
            <path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"></path>
            <path d="m2 16 6 6"></path>
            <circle cx="16" cy="9" r="2.9"></circle>
            <circle cx="6" cy="5" r="3"></circle>
          </svg>
        </div>
        <div>
          Cashback
        </div>
      </button>
    </div>

    <div v-if="!partners" class="text-center mb-5">
      <b-spinner variant="default" role="status" small></b-spinner>
    </div>

    <div v-if="partners && partners.length == 0" class="text-center mb-5">
      <p>Nenhum parceiro encontrado nesta categoria.</p>
    </div>

    <div v-else class="parceiros mb-4">
      <div class="item" v-for="(row, index) in partners" :key="index">
        <router-link class="text-dark" tag="a" :to="'/descontos/' + row.id">
          <div class="card mb-0">
            <div class="card-body p-2">
              <div class="cover">
                <img :src="row.cover" class="img-fluid">
              </div>
              <div class="d-flex justify-content-center my-3">
                <div class="logo">
                  <img :src="row.logo" class="img-fluid">
                </div>
              </div>
              <h6 class="text-center">{{ row.name }}</h6>
              <div class="d-block bg-default rounded p-1 font-size-12 text-white text-uppercase text-center">
                {{ row.offer }}
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>

    <div v-if="!categories" class="categorias d-flex justify-content-center align-items-center py-5">
      <b-spinner variant="default" role="status" small></b-spinner>
    </div>
    <div v-else-if="categories && categories.length > 0" class="categorias">
      <div class="list">
        <button class="item" :class="(category == '') ? 'active' : 'inactive text-default'" v-on:click="showCategory('')">
          <div class="item-name">
            Todos
          </div>
        </button>
        <button class="item" :class="(row.id == category) ? 'active' : 'inactive text-default'" v-for="(row, index) in categories" :key="index" v-on:click="showCategory(row)">
          <div class="item-name">
            {{ row.name }}
          </div>
        </button>
      </div>
    </div>
  </Layout>
</template>